import { InputMaybe } from "../__generated__/globalTypes";

export interface GenericFilter {
  allOf?: InputMaybe<InputMaybe<GenericFilter>[]>;
  anyOf?: InputMaybe<InputMaybe<GenericFilter>[]>;
  [key: string]: any;
}

export const combineFiltersAnd = (
  filter1: GenericFilter,
  filter2: GenericFilter
) => {
  let allOf = undefined;
  let anyOf = undefined;
  if (filter1.allOf && filter2.allOf) {
    allOf = [...filter1.allOf, ...filter2.allOf];
  } else {
    allOf = filter1.allOf || filter2.allOf || undefined;
  }
  if (filter1.anyOf && filter2.anyOf) {
    allOf = [
      ...(allOf || []),
      { anyOf: filter1.anyOf },
      { anyOf: filter2.anyOf },
    ];
  } else {
    anyOf = filter1.anyOf || filter2.anyOf || undefined;
  }
  let result = { ...filter1, ...filter2 };
  if (allOf) {
    result = { ...result, allOf };
  } else {
    delete result.allOf;
  }
  if (anyOf) {
    result = { ...result, anyOf };
  } else {
    delete result.anyOf;
  }
  return result;
};

// could create combineFiltersOr if needed

/**
 * Converts filter object to URL query parameters string
 * @param filters Object containing filter values
 * @returns URL query parameters string
 */
export function convertFiltersToQueryParams(filters: any): string {
  const params = new URLSearchParams();

  // Key mappings for renaming parameters
  const keyMappings: any = {
    filterToSelectedCollectionIds: "collections",
    filterToSelectedGhgImpactRatings: "ghg",
    filterToSelectedLandUseImpactRatings: "land_use",
    filterToSelectedWaterUseImpactRatings: "water_use",
    filterToSelectedDiets: "diets",
    filterToRequiresClientAttention: "attentions",
    intersectCollections: "intersect_collections",
    filterToSelectedIntegrationTypes: "integration_types",
  };

  Object.entries(filters).forEach(([key, value]: [string, any]) => {
    const mappedKey = keyMappings[key];

    if (Array.isArray(value) && value.length > 0) {
      // Convert non-empty arrays to comma-separated strings
      params.append(mappedKey, value.join(","));
    } else if (typeof value === "boolean" || typeof value === "number") {
      if (value !== false) {
        // Exclude `false` but include `true` and numbers
        params.append(mappedKey, value as any);
      }
    }
  });

  return params.toString();
}
